/**
 * Phase 66 Plan 02 — react-router 7 outlet guard.
 *
 * Wraps protected routes; redirects unauthenticated visitors to `/`
 * where AppShell renders the LoginPage overlay.
 *
 * Port of `js/app.js` Router.setBeforeEach (lines 346-362) split into:
 *   - this component for auth gating
 *   - <Can> wrapper for admin-role parity (D-14)
 *
 * Admin-role parity check (`role === "admin" || role === "super_admin"`)
 * is handled by `<Can>` on each /admin/* route entry, NOT here, so this
 * guard remains a single-responsibility auth gate.
 */

import { Navigate, Outlet } from "react-router";

import { useAuth } from "./AuthProvider";

export default function RequireAuth() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return <Outlet />;
}
